import invariant from "tiny-invariant";
import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { defaultData as ButtonDefaultData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/PrimaryButtonBlock/PrimaryButtonBlockDefaultData";
import { defaultData as SecondaryButtonDefaultData } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Content/SecondaryButtonBlock/SecondaryButtonBlockDefaultData";

export const createButtonBlock = ({
  text,
  href,
  buttonType = "primaryButton",
  styles = {},
}: {
  text: string;
  href: string;
  target?: string;
  buttonType?: "primaryButton" | "secondaryButton";
  styles?:
    | Record<string, StyleValue>
    | Record<string, Record<string, StyleValue>>;
}): BaseBlock => {
  const defaultData = (() => {
    if (buttonType === "primaryButton") {
      return ButtonDefaultData;
    }
    if (buttonType === "secondaryButton") {
      return SecondaryButtonDefaultData;
    }
    invariant(false, "Invalid button type");
  })();

  return {
    ...defaultData,
    id: uuidv4(),
    props: {
      ...defaultData.props,
      text: {
        ...defaultData.props.text,
        prop: "other",
        value: text,
      },
      href: {
        ...defaultData.props.href,
        prop: "other",
        value: href,
      },
      buttonType: {
        ...defaultData.props.buttonType,
        prop: "other",
        value: buttonType,
      },
      styles: {
        ...defaultData?.props?.styles,
        prop: "styles",
        type: "styles",
        value: {
          ...(defaultData?.props?.styles?.value as Record<string, StyleValue>),
          ...styles,
        },
      },
    },
  };
};
